import { render, staticRenderFns } from "./EditMilestone.vue?vue&type=template&id=0d50d0e5&"
import script from "./EditMilestone.vue?vue&type=script&lang=js&"
export * from "./EditMilestone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports